<template>
  <div>
    <icon-list v-if="isChildCare" :items="ageGroupDisplay" iconColor="#4B4C52" :customMargin="16" />
    <tag-label-group v-else-if="isPetCare" :items="petExperienceDisplay" />
    <tag-label-group v-else-if="isHousekeeping" :items="serviceExperienceDisplay" />
    <div v-else-if="isCompanionCare">
      <checkmark-list v-if="ageGroupsExperience" :tips="companionCareAgeGroupDisplay" />
      <tag-label-group
        v-if="basicCareServicesExperience"
        :items="basicServicesExperienceDisplay"
        title="Basic services"
        class="mt-16"
      />
      <tag-label-group
        v-if="personalCareServicesExperience"
        :items="personalServicesExperienceDisplay"
        title="Personal services"
        class="mt-16"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { isChildCare, isPetCare, isHousekeeping, isCompanionCare } from '../../__types__/CareTypes';
import { experienceMap, ExperienceDisplay } from '../../__types__/ExperienceTypes';
import IconList from '@/components/icon_list/IconList.vue';
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';

export default {
  name: 'ProfileExperience',
  components: { IconList, TagLabelGroup, CheckmarkList },
  props: {
    careType: {
      type: String,
      default: '',
    },
    ageGroups: {
      type: Array as () => string[],
      default: () => [],
    },
    experienceCaringFor: {
      type: Array as () => string[],
      default: () => [],
    },
    servicesExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    ageGroupsExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    basicCareServicesExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    personalCareServicesExperience: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  data(): any {
    return {
      isChildCare: isChildCare(this.careType),
      isPetCare: isPetCare(this.careType),
      isHousekeeping: isHousekeeping(this.careType),
      isCompanionCare: isCompanionCare(this.careType),
    };
  },
  computed: {
    ageGroupDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.ageGroups, 'ageGroups');
    },
    petExperienceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.experienceCaringFor, 'petExperience');
    },
    serviceExperienceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.servicesExperience, 'services');
    },
    companionCareAgeGroupDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.ageGroupsExperience, 'companionCareAges');
    },
    basicServicesExperienceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.basicCareServicesExperience, 'basicCare');
    },
    personalServicesExperienceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.personalCareServicesExperience, 'personalCare');
    },
  },
  methods: {
    mapExperienceKeys(keys: string[], mapType: keyof typeof experienceMap): ExperienceDisplay[] {
      return keys.map((key) => experienceMap[mapType]?.[key]).filter((item): item is ExperienceDisplay => !!item);
    },
  },
};
</script>
